import quickFetch from 'quick-fetch';
import { getChirpEarlyRequestName } from 'rpc-client-utils';
import { loginVerifyEarlyRequestRpc } from '../__generated__/chirp/com/hubspot/portals/platform/app/rpc/earlyRequest/AccessRpc.early';
import { getPortalAccountId, getPortalInstanceId } from './utils/metadata';
import { Metrics } from './utils/metrics';
import { usageTracker } from './utils/usageTracker';
function parseChirpUnion(responseText) {
  const parsed = JSON.parse(responseText);
  if (parsed.type === 'data') {
    return {
      type: 'data',
      data: parsed.data
    };
  }
  if (parsed.type === 'rpcError') {
    return {
      type: 'rpcError',
      rpcError: parsed.rpcError,
      correlationId: parsed.correlationId
    };
  }
  if (parsed.type === 'internalError') {
    console.error('portalsLoginVerify: CHIRP internal error', parsed.internalError);
    return undefined;
  }
  console.error('portalsLoginVerify: unexpected CHIRP response', parsed.type, parsed);
  return undefined;
}
export function getPortalsLoginVerifyEarlyRequest() {
  const startTime = performance.now();
  const requestName = getChirpEarlyRequestName(loginVerifyEarlyRequestRpc, {
    request: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    }
  });
  const requestState = quickFetch.getRequestStateByName(requestName);
  if (!requestState) {
    return Promise.resolve(undefined);
  }
  return new Promise((resolve, reject) => {
    requestState.whenFinished(response => {
      Metrics.timer('login-verify').update(performance.now() - startTime);
      try {
        var _parsed$data;
        const parsed = JSON.parse(response);
        resolve((_parsed$data = parsed.data) !== null && _parsed$data !== void 0 ? _parsed$data : parsed);
      } catch (e) {
        reject(e);
      }
    });
    requestState.onError(() => {
      Metrics.counter('login-verify-error').increment();
      resolve(undefined);
    });
  }).then(loginData => {
    const data = loginData;
    if ((data === null || data === void 0 ? void 0 : data.userId) != null) {
      usageTracker.setProperties({
        isOwner: true
      });
    }
    if (data !== null && data !== void 0 && data.email) {
      usageTracker.setProperties({
        email: data.email
      });
      usageTracker.track('Portals Platform', 'Portal Initialized', {});
    }
    return data;
  });
}
export function safeGetPortalsLoginVerifyEarlyRequest(options) {
  const startTime = performance.now();
  const requestName = getChirpEarlyRequestName(loginVerifyEarlyRequestRpc, {
    request: Object.assign({
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    }, options === null || options === void 0 ? void 0 : options.body)
  });
  const requestState = quickFetch.getRequestStateByName(requestName);
  if (!requestState) {
    return Promise.resolve(undefined);
  }
  return new Promise(resolve => {
    requestState.whenFinished(response => {
      Metrics.timer('login-verify').update(performance.now() - startTime);
      try {
        resolve(parseChirpUnion(response));
      } catch (e) {
        console.error('portalsLoginVerify: failed to parse response', e);
        resolve(undefined);
      }
    });
    requestState.onError(xhr => {
      Metrics.counter('login-verify-error').increment();
      if (xhr.status === 0) {
        console.error('portalsLoginVerify: network failure');
        resolve(undefined);
        return;
      }
      try {
        resolve(parseChirpUnion(xhr.responseText));
      } catch (e) {
        console.error('portalsLoginVerify: failed to parse error response', e);
        resolve(undefined);
      }
    });
  }).then(result => {
    var _result$data;
    if ((result === null || result === void 0 ? void 0 : result.type) === 'data' && result.data.userId != null) {
      usageTracker.setProperties({
        isOwner: true
      });
    }
    if ((result === null || result === void 0 ? void 0 : result.type) === 'data' && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.email) {
      usageTracker.setProperties({
        email: result.data.email
      });
      usageTracker.track('Portals Platform', 'Portal Initialized', {});
    }
    return result;
  });
}